import React from "react";
import * as Icon1 from "react-icons/bi";
import * as Icon3 from "react-icons/hi2";
import * as Icon2 from "react-icons/io5";
import ContactInfo from "../../assets/Images/Contact_info.png";
const contactDetails = [
  {
    icon: "HiChatBubbleLeftRight",
    heading: "Chat on us",
    description: "Our friendly team is here to help.",
    details: "ed.tech.project.ass@gmail.com",
  },
  {
    icon: "BiWorld",
    heading: "Visit us",
    description: "Come and say hello at our office HQ.",
    details: "Jadavpur near Garia, Kolkata 700092",
  },
  {
    icon: "IoCall",
    heading: "Call us",
    description: "Mon - Fri From 8am to 5pm",
    details: "+123 456 7869",
  },
];

const ContactDetails = () => {
  return (
    <div className="flex flex-col gap-6 items-center rounded-xl bg-richblack-800 
    bg-contact-background bg-cover p-4 lg:p-6">
      <img src={ContactInfo} alt="" className="w-2/3 -translate-x-10" />

      <div className="flex flex-col gap-6 p-4 lg:p-6">
        {contactDetails.map((ele, i) => {
          let Icon = Icon1[ele.icon] || Icon2[ele.icon] || Icon3[ele.icon];
          return (
            <div
              className="flex flex-row gap-[8px] p-3 text-sm text-richblack-100"
              key={i}
            >
              {" "}
              <Icon size={25} className="text-[#f3f6e7]" />
              <div className="flex flex-col items-start gap-1">
                <h1 className="text-lg font-semibold text-[#aac6fc]">
                  {ele?.heading}
                </h1>
                <p className="font-medium">{ele?.description}</p>
                <p className="font-semibold">{ele?.details}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContactDetails;
